<template>
  <div>
    <el-table :empty-text="$t('label_357')" :id="'mytable'" :data="exportData" border style="width: 100%;height: 0;opacity: 0;display: none">
      <el-table-column :align="item.align" :prop="item.column" :label="item.title" :width="item.width" v-for="(item,index) in exportList" :key="index">
      </el-table-column>
    </el-table>
  </div>

</template>

<script>
import FileSaver from 'file-saver'
import XLSX from "xlsx";
import XLSXStyle from "xlsx-style";
import utils from '@/utils/utils'
export default {
  name: "export",
  props: {
    exportData: {
      type: Array,
      default: []
    },
    exportTitle: {
      type: String,
      default: ''
    },
    exportList: {
      type: Array,
      default: []
    },
  },
  data() {
    return {
      todayTimeString:utils.getDayFormatDate(),
    }
  },
  watch: {
    exportData(newValue, oldValue) {
    },
    exportList(newValue, oldValue) {
    },
  },
  methods:{
    setExportExcel() {
      /* generate workbook object from table */
      let wb = XLSX.utils.table_to_sheet(document.querySelector("#mytable"), { raw: true });//mytable为表格的id名
      console.log(wb)
      wb["!cols"] = [{wpx:220},{wpx:80},{wpx:220},{wpx:120},{wpx:120},{wpx:120},{wpx:120},{wpx:120},{wpx:120},{wpx:120}]
      // for(let i = 0;i<11;i++){
      //   wb["!cols"][i]={wpx:240}
      // }
      // 样式的文档地址
      // https://www.npmjs.com/package/xlsx-style
      for (const key in wb) {
        if(key.indexOf('!') === -1){
          wb[key].s ={
            font:{//字体设置
              sz:11,
              name:'游ゴシック',
              bold:false,
              color:{
                rgb:'000000'//十六进制，不带#
              }
            },
            alignment:{//文字居中
              horizontal:'center',
              vertical:'center',
              wrapText:true
            },
            // border: { // 设置边框
            //   top: { style: 'thin' },
            //   bottom: { style: 'thin' },
            //   left: { style: 'thin' },
            //   right: { style: 'thin' }
            // }
          }
        }
      }
      if(wb['!merges']){
        let data = this.addRangeBorder(wb['!merges'],wb)
        let filedata = this.sheet2blob(data)
        this.openDownloadDialog(filedata,this.exportTitle + ".csv")
      }else {
        let filedata = this.sheet2blob(wb)
        this.openDownloadDialog(filedata,this.exportTitle + ".csv")
      }
    },
    //为合并项添加边框
    addRangeBorder(range,ws){
      let arr = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"];
      range.forEach(item=>{
        let startColNumber = Number(item.s.r), endColNumber = Number(item.e.r);
        let startRowNumber = Number(item.s.c), endRowNumber = Number(item.e.c);
        const test = ws[arr[startRowNumber] + (startColNumber + 1)];
        for(let col = startColNumber ; col <= endColNumber ; col++)
        {
          for(let row = startRowNumber; row <= endRowNumber ; row++)
          {
            ws[arr[row] + (col + 1)] = test;
          }
        }
      })
      return ws;
    },
    //将一个sheet转成最终的excel文件的blob对象，然后利用URL.createObjectURL下载
    sheet2blob(sheet, sheetName) {
      sheetName = sheetName || 'sheet1';
      let workbook = {
        SheetNames: [sheetName],
        Sheets: {}
      };
      workbook.Sheets[sheetName] = sheet; // 生成excel的配置项

      let wopts = {
        bookType: 'xlsx', // 要生成的文件类型
        bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
        type: 'binary'
      };
      let wbout = XLSXStyle.write(workbook, wopts);
      let blob = new Blob([s2ab(wbout)], {
        type: "application/octet-stream"
      }); // 字符串转ArrayBuffer
      function s2ab(s) {
        let buf = new ArrayBuffer(s.length);
        let view = new Uint8Array(buf);
        for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
      }
      return blob;
    },
    openDownloadDialog(url, saveName) {
      if (typeof url == 'object' && url instanceof Blob) {
        url = URL.createObjectURL(url); // 创建blob地址
      }
      let aLink = document.createElement('a');
      aLink.href = url;
      aLink.download = saveName || ''; // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
      let event;
      if (window.MouseEvent) event = new MouseEvent('click');
      else {
        event = document.createEvent('MouseEvents');
        event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      }
      aLink.dispatchEvent(event);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/list/export/export.vue